module.exports = __webpack_public_path__ + "34736292/img/settings-icon.121d9519.svg";